import { render, staticRenderFns } from "./BusinessObjHeader.vue?vue&type=template&id=d6354b86&scoped=true&"
import script from "./BusinessObjHeader.vue?vue&type=script&lang=js&"
export * from "./BusinessObjHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6354b86",
  null
  
)

export default component.exports